<template>

	<div class="row">

		<div class="col-md-12">
			<student-messages />
		</div>

	</div>

</template>

<script>

	import Highlight from './';
	export default Highlight;

</script>



// WEBPACK FOOTER //
// main.vue?0ecb59ae